import 'reset.scss/reset.scss'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/effect-fade'

import './scss/style.scss'

import $ from 'jquery';
import Swiper from 'swiper'
import { Pagination, Navigation, EffectFade, Autoplay } from 'swiper/modules'

Swiper.use([Pagination, Navigation, EffectFade, Autoplay])

$(function(){
  // IntersectionObserverを使用してクラスを付与
  const $intersectElements = $('[data-intersect]');
  
  if ($intersectElements.length > 0) {
    const $body = $('body');
    const crossingTopState = new Map();
    const intersectModifiers = Array.from(new Set(
      $intersectElements
        .map(function() {
          return String($(this).data('intersect') ?? '').trim();
        })
        .get()
        .filter(Boolean)
    ));

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        // ルートを上端1px帯にしているため、交差中かどうかで上端交差を判定できる
        crossingTopState.set(entry.target, entry.isIntersecting);
      });

      const activeModifiers = new Set();
      crossingTopState.forEach((isCrossingTop, element) => {
        if (!isCrossingTop) return;
        const modifier = String($(element).data('intersect') ?? '').trim();
        if (modifier) {
          activeModifiers.add(modifier);
        }
      });

      intersectModifiers.forEach((modifier) => {
        $body.toggleClass(`is-intersect-${modifier}`, activeModifiers.has(modifier));
      });
    }, {
      threshold: 0,
      // 判定領域をビューポート最上部のラインに限定
      rootMargin: '0px 0px -100% 0px'
    });

    $intersectElements.each(function() {
      crossingTopState.set(this, false);
      observer.observe(this);
    });
  }

  $('.js-navtoggle').on('click', function() {
    $('#nav').fadeToggle();
    $('body').toggleClass('is-navopen');
    $('#header').toggleClass('open');
  });

  const scroll = { value: 0 };
  $(window).on('scroll', function() {
    scroll.value = $(this).scrollTop();
    if (scroll.value > 100) {
      $('#header').addClass('is-scrolled');
    } else {
      $('#header').removeClass('is-scrolled');
    }
  });

  $(window).on('load resize', function(){
    const windowWidth = window.innerWidth;
    const baseHeight = $('.js-base-eachheight').height()
    
    if(windowWidth >= 768){
      $('.js-base-eachheight').each(function(){
        $(this).nextAll().css('height', baseHeight);
      })
    } else {
      $('.js-base-eachheight').each(function(){
        $(this).nextAll().css('height', 'auto');
      })
    }
  });

  // slider
  
  new Swiper(".slider", {
    loop: true,
    centeredSlides: true,
    slidesPerView: 'auto',
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    on: {
      init: function () {
        updatePaginationText(this);
      },
      slideChange: function () {
        updatePaginationText(this);
      }
    },
  });

  new Swiper("#access-gallery", {
    loop: true,
    slidesPerView: 'auto',
    spaceBetween: 20,
    speed: 10000,
    allowTouchMove: false,
    autoplay: {
      delay: 0,
      disableOnInteraction: false
    }
  });

  new Swiper("#technology-gallery", {
    loop: true,
    slidesPerView: 'auto',
    spaceBetween: 20,
    speed: 10000,
    allowTouchMove: false,
    autoplay: {
      delay: 0,
      disableOnInteraction: false
    }
  });

  // home 当院を選ばれる方
  $('.fitable-points-list li:nth-child(2)').on('mouseenter', function(){
    $(this).parent().children('li').first().find('.fitable-points-text').css('opacity', 0)
  });
  $('.fitable-points-list li:nth-child(3)').on('mouseenter', function(){
    $(this).parent().children('li').first().find('.fitable-points-text').css('opacity', 0)
  });
})

function updatePaginationText(swiper) {
  const current = String(swiper.realIndex + 1);
  const total = String(swiper.slides.length);
  const swiperEl = swiper.el;
  swiperEl.querySelector('.swiper-pagination-current').textContent = String(current).padStart(2, '0');
  swiperEl.querySelector('.swiper-pagination-total').textContent = String(total).padStart(2, '0');
}